import { CollectibleObject } from '../types';
import objectsData from './objects.json';

// Transform JSON data to match existing CollectibleObject interface
export const allObjects: CollectibleObject[] = objectsData.objects.map(obj => ({
  id: obj.id,
  name: obj.translations.fr.name, // Default to French for compatibility
  emoji: obj.assetUrl, // Using PNG asset URL instead of emoji
  bookId: obj.rewardFrom.bookId,
  bookTitle: `Livre ${obj.rewardFrom.bookId}` // Temporary title
}));

// Export the raw JSON data for components that want to use translations
export const objectsWithTranslations = objectsData.objects;

export default allObjects;